/**
 * @ngdoc directive
 * @name flowLibraryHeader
 * @module flowingly.runner.library
 * @description  This component is used to display the header for the flow library and will contain controls
 * @usage
 * ```
      <flow-library-header></flow-library-header>
 * ``` 
 */
import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';

angular.module('flowingly.runner.library').component('flowLibraryHeader', {
  bindings: {
    canCreateFlows: '<'
  },
  templateUrl: 'Client/runner.library/runner.library.header.tmpl.html',
  controller: [
    'tempModelerUrlService',
    '$state',
    'APP_CONFIG',
    'appInsightsService',
    'dialogService',
    'permissionsService',
    'tokenService',
    function (
      tempModelerUrlService: SharedAngular.TempModelerUrlService,
      $state: IStateService,
      APP_CONFIG: SharedAngular.APP_CONFIG,
      appInsightsService: SharedAngular.AppInsightsService,
      dialogService: SharedAngular.DialogService,
      permissionsService: SharedAngular.PermissionsService,
      tokenService: SharedAngular.TokenService
    ) {
      this.isRecordingProcedure = false;
      this.currentTabName = window.location.pathname
        .split('/')
        .filter(Boolean)
        .pop();
      this.templateLibraryEnabled = APP_CONFIG.enableTemplateLibrary;
      this.showImportButton = permissionsService.currentUserHasPermission(
        FlowinglyPermissions.FLOWMODEL_BULKIMPORT
      );
      this.isProcedureRecordingExtensionInstalled = false;
      window.addEventListener('FlowinglyProcedurePingAck', () => {
        this.isProcedureRecordingExtensionInstalled = true;
      });
      window.addEventListener('FlowinglyProcedureRecorded', () => {
        this.isRecordingProcedure = false;
      });
      const event = new CustomEvent('FlowinglyProcedurePing');
      window.dispatchEvent(event);

      this.onAddFlowModelClick = () => {
        tempModelerUrlService.openModeler();
      };

      this.viewTemplatesClicked = () => {
        $state.go('app.runner.templates.library');
        appInsightsService.trackPageView('template-library', {
          from: 'library'
        });
      };

      this.importFlowModelsClicked = () => {
        dialogService.showDialog({
          template:
            'Client/runner.import/flowmodels/runner.import.flowmodels.dialog.tmpl.html',
          controller: 'importFlowModelsDialogController',
          appendClassName: 'ngdialog-normal'
        });
      };

      this.activateProcedureExtension = () => {
        dialogService
          .showDialog({
            template:
              'Client/runner.library/runner.library.procedures/runner.library.procedures.dialog.tmpl.html',
            controller: 'procedureDialogController',
            appendClassName: 'ngdialog-normal'
          })
          .then((procedureDetails: { name: string; id: Guid }) => {
            if (dialogService.isCloseModalWithCancelAction(procedureDetails)) {
              return;
            }
            const event = new CustomEvent('FlowinglyProcedureActivate', {
              detail: {
                flowinglyUserToken: tokenService.getToken(),
                procedureName: procedureDetails.name,
                procedureId: procedureDetails.id,
                publicApiUrl: (window.location.origin + '/public/').replace(
                  'localhost:9000',
                  'localhost:49212'
                ),
                procedureUrl: window.location.origin + '/sops/',
                maximumActions: 40
              }
            });
            window.dispatchEvent(event);
            this.isRecordingProcedure = true;
          });
      };
    }
  ]
});
